/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Docslink3Inputs */

const en_settings_reportingapikeys_docslink3 = /** @type {(inputs: Settings_Reportingapikeys_Docslink3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API documentation`)
};

/**
* | output |
* | --- |
* | "API documentation" |
*
* @param {Settings_Reportingapikeys_Docslink3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_docslink3 = /** @type {((inputs?: Settings_Reportingapikeys_Docslink3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Docslink3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_docslink3(inputs)
});
export { settings_reportingapikeys_docslink3 as "settings_reportingApiKeys_docsLink" }